import { createSelector } from 'reselect';

import { PANEL_CONFIGURATIONS } from '../../constants/PanelLayoutConstants';
import { getPanelLayout } from '../../form-designer/selectors/common.selectors';
import {
  detailFormHasSelectedSubGrids,
  stepFormHasSelectedSubGrids,
} from '../../form-designer/selectors/runtime.selectors';

export const getPillText = (formKey) => (state) => {
  const form = state.formDesigner[formKey];

  const { actionName } = form?.workflowInfo ?? {};
  const translatedStepName = form?.data?.formInfo?.translatedStepName;
  const stepName = form?.data?.formInfo?.stepName;

  return translatedStepName || actionName || stepName || '';
};

export const getAttachmentModalOpen = (state) => state.entityDisplayPage.attachmentModalOpen;

export const getOpenErrorsTabEntityDisplay = (state) => state.entityDisplayPage.openErrorsTab;

export const getOpenStepFormTabEntityDisplay = (state) => state.entityDisplayPage.openStepFormTab;

export const getOpenDetailFormTabEntityDisplay = (state) =>
  state.entityDisplayPage.openDetailFormTab;

export const getHeaderSectionWidthPercentBasedOnSelectedSubGrids = createSelector(
  [stepFormHasSelectedSubGrids, detailFormHasSelectedSubGrids, getPanelLayout],
  (stepFormHasSubGrids, detailFormHasSubGrids, { config }) => {
    if (stepFormHasSubGrids) {
      switch (config) {
        case PANEL_CONFIGURATIONS.ALL_EXPANDED:
        case PANEL_CONFIGURATIONS.RIGHT_COLLAPSED:
        case PANEL_CONFIGURATIONS.MIDDLE_COLLAPSED:
          return 60;

        case PANEL_CONFIGURATIONS.LEFT_COLLAPSED:
        case PANEL_CONFIGURATIONS.ONLY_MIDDLE:
        case PANEL_CONFIGURATIONS.ONLY_RIGHT:
          return 50;

        default:
          return 100;
      }
    }

    if (detailFormHasSubGrids) {
      switch (config) {
        case PANEL_CONFIGURATIONS.ALL_EXPANDED:
        case PANEL_CONFIGURATIONS.MIDDLE_COLLAPSED:
          return 60;

        case PANEL_CONFIGURATIONS.LEFT_COLLAPSED:
        case PANEL_CONFIGURATIONS.ONLY_RIGHT:
          return 50;

        default:
          return 100;
      }
    }

    return 100;
  }
);
